// extracted by mini-css-extract-plugin
module.exports = {"button":"_2PPQdQ9fz8g2Cx7DPrAbRj","icons":"_2PMhxCqUPbo18kwhzRk3Op","icon":"_3NsP8Dmhb3Jzs8hRIfjb67","shareButton":"_3_GZXmzq4LCnNo4nSIyDA0","copyButton":"u-JILNPTsL0MvUdPYaWtk"};